// import type { Value as DfValue } from 'urt-cloud-data'
// import type { OnDataChangeListener } from 'urt-cloud-data/lib/cloud-data/syncer/DataCache'
import type { Value as DfValue } from '@core/UCloudDataWebSDK/cloud-data/network/Model'
import type { OnDataChangeListener } from '@core/UCloudDataWebSDK/cloud-data/syncer/DataSyncer'
import type { NoticeEventDispatcher } from '@core/databus/NoticeEventDispatcher'
import {
  NoticeAddedEventDispatcher,
  NoticeRemovedEventDispatcher,
  NoticeUpdatedEventDispatcher,
} from '@core/databus/NoticeEventDispatcher'
import { NoticeFactory } from '@core/databus/NoticeDataBuilders'
import type { ActionNoticeData, AsyncOperationEventData, TransmissionNoticeData } from '@core/databus/DataSyncManager'
import type { NoticeEventChangeCallback } from '@core/databus/IDataSyncManager'
import { getTimestamp } from '@core/databus/NoticeDataUtils'
import { isObject } from '@core/Utils'

/**
 * A group of DataSync callback functions, which group by notice type.
 */
export interface EventCallbackGroup {
  actionNotice: Array<NoticeEventChangeCallback<ActionNoticeData>>
  asyncOperationEvent: Array<NoticeEventChangeCallback<AsyncOperationEventData>>
  transmissionNotice: Array<NoticeEventChangeCallback<TransmissionNoticeData>>
}

/**
 * An aggregator of DataSync event's callback
 */
export interface EventCallbackAggregator {
  getAllOnAddedCallbacks(): EventCallbackGroup
  getAllOnUpdatedCallbacks(): EventCallbackGroup
  getAllOnRemovedCallbacks(): EventCallbackGroup
}

/**
 * Listens to the data change events from the data sync service, and then dispatches the corresponding notice events
 */
export class DataSyncEventChangeListener implements OnDataChangeListener<DfValue> {
  readonly #callbackGetter: EventCallbackAggregator

  constructor(callbackGetter: EventCallbackAggregator) {
    this.#callbackGetter = callbackGetter
  }

  onDataAdded(packageName: string, value: Map<string, DfValue>) {
    console.log(`[DataSyncManager] ${new Date().toLocaleString()} `, `同步中心的onDataAdded事件触发`)
    DataSyncEventChangeListener.#notifyChange(value, new NoticeAddedEventDispatcher(this.#callbackGetter))
  }

  // onDataChanged(packageName: string, value: Map<string, DfValue>) {
  //   console.log(`[DataSyncManager] ${new Date().toLocaleString()} `, `同步中心的onDataChanged事件触发`)
  //   DataSyncEventChangeListener.#notifyChange(value, new NoticeUpdatedEventDispatcher(this.#callbackGetter))
  // }

  // onDataRemoved(packageName: string, value: Map<string, DfValue>) {
  //   console.log(`[DataSyncManager] ${new Date().toLocaleString()} `, `同步中心的onDataRemoved事件触发`)
  //   DataSyncEventChangeListener.#notifyChange(value, new NoticeRemovedEventDispatcher(this.#callbackGetter))
  // }

  static #handleRawNoticeData(rawData: Map<string, DfValue>) {
    const noticeList = []
    let noticeData = undefined

    for (const id of rawData.keys()) {
      try {
        const rawValue = rawData.get(id)

        if (rawValue) {
          noticeData = JSON.parse(rawValue.eventValue)

          if (isObject(noticeData)) {
            noticeData.timestamp = getTimestamp(id)
            noticeList.push(noticeData)
          }
        }
      } catch (error) {
        console.error('got error when parse notice data:', error)
      }
    }

    return noticeList
  }

  static #notifyChange(rawData: Map<string, DfValue>, noticeDispatcher: NoticeEventDispatcher) {
    const noticeList = DataSyncEventChangeListener.#handleRawNoticeData(rawData)

    console.log(`[DataSyncManager] ${new Date().toLocaleString()} `, '数据序列化为：', noticeList)

    for (const notice of noticeList) {
      const builder = NoticeFactory.getBuilder(notice?.category)

      if (builder) {
        const noticeData = builder.fromJson(notice).build()

        console.log(
          `[DataSyncManager] ${new Date().toLocaleString()} `,
          '构建前数据为:',
          notice,
          '数据构建为：',
          noticeData
        )
        noticeData && noticeDispatcher.append(noticeData)
      }
    } // end for
    noticeDispatcher.notifyChanges()
  }
}
